module.exports = __webpack_public_path__ + "static/img/y53.a710471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y53.jpg
// module id = ILsi
// module chunks = 1